var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerbindlichkeiten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8265 18.0469V16.7062C17.8265 16.6453 17.7796 16.5938 17.714 16.5938H11.4796C11.4187 16.5938 11.3718 16.6406 11.3718 16.7062V18.0469C11.3718 18.1078 11.4187 18.1547 11.4796 18.1547H17.7187C17.7796 18.1547 17.8265 18.1078 17.8265 18.0469Z",
    fill: "url(#paint0_linear_2227_85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0813 7.65937C10.6829 6.83437 13.3172 6.83437 15.9235 7.65937C15.5063 4.05 13.7532 0 12 0C10.2469 0 8.4938 4.05 8.0813 7.65937Z",
    fill: "url(#paint1_linear_2227_85)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5296 18.5437H11.4796C11.4187 18.5437 11.3718 18.5953 11.3718 18.6562V19.9968C11.3718 20.0578 11.4187 20.1046 11.4796 20.1046H15.5296C15.5203 20.0718 15.5156 20.0343 15.5156 19.9968V18.6562C15.5156 18.614 15.5203 18.5765 15.5296 18.5437Z",
    fill: "url(#paint2_linear_2227_85)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6108 7.43442V16.2094H12.3843V7.43442C12.1265 7.42974 11.8687 7.42974 11.6108 7.43442Z",
    fill: "url(#paint3_linear_2227_85)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59066 18.5438C6.66566 18.6938 6.79691 18.8016 6.94691 18.8485V17.6813C6.91879 17.6906 6.89066 17.7 6.86254 17.7141C6.56254 17.8688 6.43598 18.2391 6.59066 18.5438Z",
    fill: "url(#paint4_linear_2227_85)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 19.3031V20.4703C7.36406 20.4609 7.39219 20.4515 7.42031 20.4375C7.56563 20.3625 7.67812 20.2359 7.72969 20.0812C7.78125 19.9265 7.76719 19.7578 7.69687 19.6125C7.61719 19.4625 7.48594 19.3547 7.33594 19.3031Z",
    fill: "url(#paint5_linear_2227_85)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13901 16.3453C5.63433 16.3453 4.41089 17.5688 4.41089 19.0781C4.41089 20.5828 5.63433 21.811 7.13901 21.811C8.6437 21.811 9.87183 20.5875 9.87183 19.0781C9.87183 17.5735 8.64839 16.3453 7.13901 16.3453ZM8.09526 20.2031C8.01089 20.4563 7.83276 20.6625 7.5937 20.7844C7.50933 20.8266 7.42495 20.8547 7.33589 20.8735V21.0188C7.33589 21.1266 7.25151 21.211 7.1437 21.211C7.03589 21.211 6.95151 21.1266 6.95151 21.0188V20.8735C6.90933 20.8641 6.87183 20.8547 6.82964 20.8453C6.57651 20.761 6.37026 20.5828 6.24839 20.3438C6.20151 20.25 6.23901 20.1328 6.33276 20.086C6.42651 20.0391 6.5437 20.0766 6.59058 20.1703C6.66558 20.3156 6.79214 20.4281 6.94683 20.4797V19.2563C6.64683 19.1953 6.38901 19.0078 6.2437 18.7266C5.99526 18.2297 6.19683 17.625 6.68901 17.3766C6.77339 17.3344 6.85776 17.311 6.94683 17.2922V17.1422C6.94683 17.0344 7.0312 16.95 7.13901 16.95C7.24683 16.95 7.3312 17.0344 7.3312 17.1422V17.2922C7.62651 17.3485 7.88901 17.536 8.03433 17.8219C8.0812 17.9156 8.0437 18.0328 7.94995 18.0797C7.8562 18.1266 7.73901 18.0891 7.69214 17.9953C7.61714 17.8453 7.48589 17.7375 7.33589 17.686V18.9094C7.63589 18.9703 7.8937 19.1578 8.03901 19.4391C8.1562 19.6735 8.17964 19.9453 8.09526 20.2031Z",
    fill: "url(#paint6_linear_2227_85)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1187 16.3688C10.6125 15.45 9.99844 14.6719 9.31406 14.1235C9.50625 14.55 9.57656 15.1406 9.13125 15.8485C9.09375 15.9047 9.03281 15.9375 8.96719 15.9375C8.92969 15.9375 8.89688 15.9281 8.86406 15.9094C8.775 15.8531 8.74688 15.7313 8.80313 15.6422C9.23438 14.9578 9.09375 14.4188 8.82187 14.0391C8.79844 14.4938 8.57812 15.136 7.64062 15.6235C7.6125 15.6375 7.57969 15.6469 7.55156 15.6469C7.48125 15.6469 7.41562 15.6094 7.37812 15.5438C7.33125 15.45 7.36406 15.3328 7.4625 15.2813C8.33437 14.8313 8.46562 14.25 8.43281 13.8703H5.57344C5.49844 13.8703 5.42813 13.8563 5.35781 13.8375C3.19219 15.225 1.64062 18.975 1.64062 22.1906C1.64062 23.2219 4.00781 24 7.13906 24C8.6625 24 10.0078 23.8125 10.9828 23.5078V22.5469C10.9828 22.4344 11.0203 22.3266 11.0859 22.2469C11.0203 22.1625 10.9828 22.0594 10.9828 21.9422V20.6016C10.9828 20.4891 11.0203 20.3813 11.0859 20.3016C11.0203 20.2172 10.9828 20.1141 10.9828 19.9969V18.6563C10.9828 18.5438 11.0203 18.436 11.0859 18.3516C11.0203 18.2672 10.9828 18.1641 10.9828 18.0516V16.711C10.9828 16.575 11.0391 16.4578 11.1187 16.3688ZM7.13906 22.1953C5.41875 22.1953 4.02188 20.7985 4.02188 19.0781C4.02188 17.3578 5.41875 15.961 7.13906 15.961C8.85938 15.961 10.2563 17.3625 10.2563 19.0781C10.2609 20.7985 8.85938 22.1953 7.13906 22.1953Z",
    fill: "url(#paint7_linear_2227_85)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5296 20.489H11.4796C11.4187 20.489 11.3718 20.5406 11.3718 20.6015V21.9421C11.3718 22.0031 11.4187 22.0546 11.4796 22.0546H15.5296C15.5203 22.0218 15.5156 21.9843 15.5156 21.9421V20.6015C15.5156 20.564 15.5203 20.5265 15.5296 20.489Z",
    fill: "url(#paint8_linear_2227_85)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68755 7.67341C8.02974 4.57498 9.32349 1.24685 10.8516 0.0609131C6.5813 0.520288 3.02349 3.49685 1.8938 7.64998C4.38755 6.89529 5.1938 6.83904 7.68755 7.67341Z",
    fill: "url(#paint9_linear_2227_85)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57822 12.3328H8.7001C8.71885 12.3328 8.73291 12.3375 8.74697 12.3375L9.62354 10.5656C9.49229 10.5937 9.35166 10.6078 9.19229 10.6171C8.5501 10.65 7.91728 10.5281 7.30791 10.4109C7.00791 10.3546 6.70322 10.2937 6.40322 10.2562C5.86885 10.1859 5.13291 10.1625 4.51416 10.425L5.47041 12.3421C5.50791 12.3375 5.54541 12.3328 5.57822 12.3328Z",
    fill: "url(#paint10_linear_2227_85)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3595 23.8875V22.5469C22.3595 22.486 22.3126 22.4391 22.247 22.4391H16.0126C15.9517 22.4391 15.9048 22.486 15.9048 22.5469V23.8875C15.9048 23.9485 15.9517 24 16.0126 24H22.2517C22.3126 24 22.3595 23.9485 22.3595 23.8875Z",
    fill: "url(#paint11_linear_2227_85)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 0.0656738C14.6766 1.24692 15.9703 4.57505 16.3125 7.67817C18.8109 6.8438 19.6125 6.90005 22.1109 7.65474C20.9766 3.49692 17.4187 0.520361 13.1484 0.0656738Z",
    fill: "url(#paint12_linear_2227_85)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70005 13.4719C8.79849 13.4719 8.89692 13.4344 8.96724 13.3594C9.03755 13.289 9.07505 13.1953 9.07505 13.0922C9.07505 12.8859 8.9063 12.7172 8.70005 12.7172H5.57817C5.47505 12.7172 5.3813 12.7547 5.31099 12.825C5.24067 12.8953 5.19849 12.989 5.19849 13.0922C5.19849 13.2984 5.36724 13.4672 5.57349 13.4672H8.70005V13.4719Z",
    fill: "url(#paint13_linear_2227_85)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4796 24H15.5296C15.5203 23.9672 15.5156 23.9297 15.5156 23.8875V22.5469C15.5156 22.5094 15.5203 22.4719 15.5296 22.4391H11.4796C11.4187 22.4391 11.3718 22.486 11.3718 22.5469V23.8875C11.3718 23.9485 11.4187 24 11.4796 24Z",
    fill: "url(#paint14_linear_2227_85)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0126 22.0546H22.2517C22.3126 22.0546 22.3642 22.0031 22.3642 21.9421V20.6015C22.3642 20.5406 22.3173 20.489 22.2517 20.489H16.0126C15.9517 20.489 15.9048 20.5406 15.9048 20.6015V21.9421C15.9048 22.0031 15.9517 22.0546 16.0126 22.0546Z",
    fill: "url(#paint15_linear_2227_85)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2517 18.5437H16.0126C15.9517 18.5437 15.9048 18.5953 15.9048 18.6562V19.9968C15.9048 20.0578 15.9517 20.1046 16.0126 20.1046H22.2517C22.3126 20.1046 22.3642 20.0578 22.3642 19.9968V18.6562C22.3595 18.5953 22.3126 18.5437 22.2517 18.5437Z",
    fill: "url(#paint16_linear_2227_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2227_85",
    x1: 14.5992,
    y1: 16.5938,
    x2: 14.5992,
    y2: 18.1547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2227_85",
    x1: 12.0024,
    y1: 0,
    x2: 12.0024,
    y2: 7.65937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2227_85",
    x1: 13.4507,
    y1: 18.5437,
    x2: 13.4507,
    y2: 20.1046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2227_85",
    x1: 11.9976,
    y1: 7.43091,
    x2: 11.9976,
    y2: 16.2094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2227_85",
    x1: 6.73566,
    y1: 17.6813,
    x2: 6.73566,
    y2: 18.8485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2227_85",
    x1: 7.5483,
    y1: 19.3031,
    x2: 7.5483,
    y2: 20.4703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2227_85",
    x1: 7.14135,
    y1: 16.3453,
    x2: 7.14135,
    y2: 21.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2227_85",
    x1: 6.37968,
    y1: 13.8375,
    x2: 6.37968,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2227_85",
    x1: 13.4507,
    y1: 20.489,
    x2: 13.4507,
    y2: 22.0546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2227_85",
    x1: 6.37269,
    y1: 0.0609131,
    x2: 6.37269,
    y2: 7.67341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2227_85",
    x1: 7.06884,
    y1: 10.2095,
    x2: 7.06884,
    y2: 12.3421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2227_85",
    x1: 19.1321,
    y1: 22.4391,
    x2: 19.1321,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2227_85",
    x1: 17.6297,
    y1: 0.0656738,
    x2: 17.6297,
    y2: 7.67817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2227_85",
    x1: 7.13676,
    y1: 12.7172,
    x2: 7.13676,
    y2: 13.4719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2227_85",
    x1: 13.4507,
    y1: 22.4391,
    x2: 13.4507,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2227_85",
    x1: 19.1345,
    y1: 20.489,
    x2: 19.1345,
    y2: 22.0546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2227_85",
    x1: 19.1345,
    y1: 18.5437,
    x2: 19.1345,
    y2: 20.1046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40330D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbindlichkeiten);
export default __webpack_public_path__ + "static/media/verbindlichkeiten.49ab332af957b2b38d59eb52b707079f.svg";
export { ForwardRef as ReactComponent };